import { SvcTestAcceptabilitySummary, SvcTestRepeatabilitySummary, TestResults } from "../../PulmonaryFunctionTests/Shared/PFTAPITypes";
import { ParameterTypeName } from "./ParameterTypes";

export function MapSvcTestAcceptabilitySummaries(testResults: TestResults[]): Array<SvcTestAcceptabilitySummary> {
    return testResults.map(tr => {
        return {
            TestId: tr.TestId,
            Accepted: tr.OverreaderAcceptability,
            Vc: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_VC)?.Value,
            Ic: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_IC)?.Value,
            Ivc: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_IVC)?.Value,
            Frc: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_FRC)?.Value,
            Tv: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_TV)?.Value,
            Rv: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_RV)?.Value,
            Tlc: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_TLC)?.Value,
            Erv: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_ERV)?.Value,
            Evc: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_EVC)?.Value,
        } as SvcTestAcceptabilitySummary;
    })
}

export function MapSvcTestRepeatabilitySummary(testResults: TestResults[]): Array<SvcTestRepeatabilitySummary> {
    return testResults.map(tr => {
        return {
            TestId: tr.TestId,
            Accepted: tr.OverreaderAcceptability,
            Vc: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_VC)?.Value,
            Ic: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_IC)?.Value,
        } as SvcTestRepeatabilitySummary;
    })
}
